module.exports = __webpack_public_path__ + "static/media/life-sphere.fe8d10a3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/life-sphere.gif
// module id = 115
// module chunks = 48